import { useState } from "react";
import { useGetXpLeaderboardQuery } from "../../store/api/leaderboardApi";
import LeaderBoardHeader from "./LeaderboardHeader";
import LeaderboardTable from "./LeaderboardTable";
import SideColumn from "./SideColumn";

export enum LEADERBOARD_TYPES {
  DAILY = "daily",
  WEEKLY = "weekly",
  LIFETIME = "lifetime",
}

export interface pageType {
  lifetime: number;
  weekly: number;
  daily: number;
}

const LeaderboardPage = () => {
  const [type, setType] = useState<LEADERBOARD_TYPES>(
    LEADERBOARD_TYPES.LIFETIME,
  );
  const [page, setPage] = useState<pageType>({
    lifetime: 0,
    daily: 0,
    weekly: 0,
  });
  const { data, isLoading } = useGetXpLeaderboardQuery({
    page: page[type],
    type,
  });

  return (
    <div className="flex flex-col-reverse md:flex-row items-start justify-center gap-6 bg-gray-100 px-2">
      <div className="flex flex-col gap-6 w-full md:w-auto">
        <LeaderBoardHeader type={type} setType={setType} />
        <div className="w-full md:hidden">
          <SideColumn data={data} type={type} />
        </div>
        <div className="w-full">
          <LeaderboardTable
            type={type}
            isLoading={isLoading}
            page={page[type]}
            setPage={setPage}
            isEnd={data?.is_end}
            leaderboardData={data?.leaderboard || []}
          />
        </div>
      </div>
      <div className="md:sticky md:top-24 hidden md:flex">
        <SideColumn data={data} type={type} />
      </div>
    </div>
  );
};

export default LeaderboardPage;
